import React from 'react';
import { IProductCatalogItem, IProductCatalogQueryParamsForDelivery, IQueryResult } from 'gen/ApiClient';

export interface IContext {
	params: IProductCatalogQueryParamsForDelivery;
	setParams: React.Dispatch<React.SetStateAction<IProductCatalogQueryParamsForDelivery>>;
	queryResult: IQueryResult<IProductCatalogItem> | undefined;
}

export const SearchContext = React.createContext<IContext>(undefined as any);
